import { render, staticRenderFns } from "./px-money.vue?vue&type=template&id=a3b61f32&scoped=true&"
import script from "./px-money.vue?vue&type=script&lang=ts&"
export * from "./px-money.vue?vue&type=script&lang=ts&"
import style0 from "./px-money.vue?vue&type=style&index=0&id=a3b61f32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b61f32",
  null
  
)

export default component.exports